var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-dialog',{attrs:{"value":"true","persistent":"","max-width":"800px"}},[_c('SignUpForm')],1),_c('Map',{attrs:{"id":"map"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }